/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * All possible Unsupported Media Type problems.
 */
export type UnsupportedMediaTypeProblems = Truvity.UnsupportedMediaTypeProblems.UnsupportedMediaType;

export namespace UnsupportedMediaTypeProblems {
    export interface UnsupportedMediaType extends Truvity.ProblemUnsupportedMediaType {
        type: '/unsupported-media-type';
    }
}
